import React from 'react';
import { useSelector } from 'react-redux';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { makeSelectAplDetail } from 'pages/product-apl-detail/controllers/selectors';
import { ButtonSmallIcon } from 'common/components';

import { useCheckDisabledMasterAplBtn } from '../../sections/product-apl/hooks';

import { MASTER_APL_NAME } from '../../sections/product-apl/constants';
import Messages from 'i18n/messages/apl';

const SendQuestions = (props) => {
  const { setSendType, setSendModalVisible, productList } = props;

  const onClickBtn = () => {
    setSendType('question');
    setSendModalVisible(true);
  };

  const aplDetail = useSelector(makeSelectAplDetail());

  const isDisabledMasterAplBtn = useCheckDisabledMasterAplBtn(aplDetail);

  const checkDisableSendQuestionBtn = () => {
    if (productList?.length !== 1) return true;
    if (aplDetail?.aplName === MASTER_APL_NAME) {
      return isDisabledMasterAplBtn;
    }
    return false;
  };

  const isDisabled = checkDisableSendQuestionBtn();

  return (
    <ButtonSmallIcon
      className='button-item-dropdown'
      icon={<QuestionCircleOutlined />}
      label={Messages.sendQuestions}
      disabled={isDisabled}
      onClick={onClickBtn}
    />
  );
};

export default SendQuestions;
